<template>
    <div>
        <h2>Contact Us</h2>
        <p>Insert contact information for your orchestra here.</p>
    </div>
</template>

<script>
    export default {
        name: 'ContactView'
    };
</script>

<style scoped>
    /* Add your styles here */
</style>
